import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { observer } from "mobx-react";
import * as React from "react";
import { HXIconButton } from "./HXButton";
import { HXMenu, HXMenuController } from "./HXMenu";
export const HXIconMenuButton = observer((props) => {
    const { children, onClick, ...buttonProps } = props;
    const controller = new HXMenuController();
    return (_jsxs(_Fragment, { children: [_jsx(HXIconButton, { onClick: (e) => {
                    controller.openMenu(e.currentTarget);
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
                }, ...buttonProps, children: props.icon ? React.createElement(props.icon) : _jsx(MoreHoriz, {}) }), _jsx(HXMenu, { controller: controller, verticalMenuOffset: props.verticalMenuOffset, children: children })] }));
});
